import { FlowContext } from 'src/lib/flow';
import { FlowPage } from 'src/lib/flow/FlowPage';
import { CheckboxGroupQuestion } from 'src/lib/flow/FlowQuestion';
import { youAre } from 'src/lib/flow/text';

function isEnabled({ inputContext: { inApp, eligibleProducts } }: FlowContext) {
  const opendoorDirectEligible = eligibleProducts.includes('opendoor_direct');
  return opendoorDirectEligible && inApp !== true;
}

function title({ answers, inputContext: { channel } }: FlowContext): string {
  return `Select all the reasons ${youAre(answers, channel)} selling`;
}

const sellingReasonPage: FlowPage = {
  slug: () => 'selling-reason',
  title,
  isEnabled,
  autoAdvance: () => true,
  questions: (): CheckboxGroupQuestion[] => [
    {
      key: 'seller.selling_reason',
      type: 'multi_select',
      options: [
        { label: `Upgrading`, value: 'upgrading' },
        { label: `Downsizing`, value: 'downsizing' },
        { label: 'Unlocking equity', value: 'need_cash' },
        { label: 'Relocating', value: 'relocating' },
        { label: 'Retiring', value: 'retiring' },
        { label: 'Selling second home', value: 'investment_property' },
      ],
      optional: true,
      showNoneOfTheAbove: false,
    },
  ],
};

export default sellingReasonPage;
